import { ref } from "@vue/runtime-core";
import { defineStore } from "pinia";

export const useNotificationStore = defineStore("notification", () => {
  const message = ref<string>("");
  const type = ref<"success" | "error" | null>(null);
  const timeout = ref<number | null>(null);

  const showSuccess = (msg: string) => {
    message.value = msg;
    type.value = "success";
    clearTimeout(timeout.value!);
    timeout.value = window.setTimeout(() => {
      message.value = "";
      type.value = null;
    }, 3000);
  };

  const showError = (msg: string) => {
    message.value = msg;
    type.value = "error";
    clearTimeout(timeout.value!);
    timeout.value = window.setTimeout(() => {
      message.value = "";
      type.value = null;
    }, 5000);
  };

  const showNotification = (
    msg: string,
    notifType: "success" | "error" | "warning" = "success"
  ) => {
    message.value = msg;
    if (notifType === "warning") {
      type.value = "error"; // Utiliser error pour warning car nous n'avons que success et error
    } else {
      type.value = notifType as "success" | "error";
    }
    clearTimeout(timeout.value!);
    const timeoutDuration =
      notifType === "error" || notifType === "warning" ? 5000 : 3000;
    timeout.value = window.setTimeout(() => {
      message.value = "";
      type.value = null;
    }, timeoutDuration);
  };

  return {
    message,
    type,
    showSuccess,
    showError,
    showNotification,
  };
});
